import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const TabWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 24px 0;
`

export const FormButton = styled.div`
  display: flex;
  justify-content: right;
  margin-top: 42px;
  gap: 8px;
`

export const FormulaWrapper = styled.div`
  background: rgba(0,0,0,.03);
  padding: 16px;
  border-radius: 4px;
  margin: 8px 0 24px;
`
